import env from '@maui-mf/env'
import { useAuthProvider } from '@maui-mf/common-react'
import React, { createContext, useContext, useMemo } from 'react'

const defaultContext = {
  isGTI: false,
  virusTotalRoot: env.VIRUSTOTAL_UI_ROOT || 'https://www.virustotal.com/gui',
  navigate: href => {
    history.pushState({}, '', href)
  }
}

export const IndicatorsTableContext = createContext(defaultContext)

export const useIndicatorsTableContext = () => useContext(IndicatorsTableContext)

export const IndicatorsTableContextProvider = ({
  isGTI: propsIsGTI,
  navigate,
  virusTotalRoot,
  ...props
}) => {
  const { isGTI: authIsGTI } = useAuthProvider()
  const isGTI = propsIsGTI ?? authIsGTI

  const value = useMemo(() => ({
    isGTI: isGTI ?? defaultContext.isGTI,
    navigate: navigate ?? defaultContext.navigate,
    virusTotalRoot: virusTotalRoot ?? defaultContext.virusTotalRoot,
  }), [
    isGTI,
    navigate,
    virusTotalRoot,
  ])

  return <IndicatorsTableContext.Provider {...props} value={value} />
}
